import React from 'react';
import { Bell } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useAttractionNotifications } from '../../contexts/AttractionNotificationContext';

const getAttractionId = (attraction = {}) => String(
  attraction.id || attraction.externalId || attraction.external_id || attraction.api_id || attraction.code || attraction.uuid || ''
).trim();

const AttractionNotificationBell = ({
  attraction,
  parkId,
  parkSlug,
  parkName,
  className = '',
}) => {
  const { t } = useTranslation();
  const {
    getAlertForAttraction,
    openAttractionNotification,
  } = useAttractionNotifications();

  const resolvedParkSlug = String(parkSlug || attraction?.parkSlug || attraction?.park_slug || parkId || attraction?.parkId || '').trim();
  const attractionId = getAttractionId(attraction);
  const entityType = String(attraction?.entityType || attraction?.type || '').toUpperCase();
  const activeAlert = getAlertForAttraction(resolvedParkSlug, attractionId);

  if (entityType === 'RESTAURANT' || entityType === 'SHOW') return null;
  if (!resolvedParkSlug || !attractionId) return null;

  const title = activeAlert
    ? t('attractionNotifications.bell.activeTitle', 'Alerte active')
    : t('attractionNotifications.bell.title', 'Créer une alerte');

  return (
    <button
      type="button"
      className={`attraction-notification-bell ${activeAlert ? 'active' : ''} ${className}`.trim()}
      aria-label={title}
      title={title}
      onClick={(event) => {
        event.preventDefault();
        event.stopPropagation();
        openAttractionNotification({
          attraction,
          parkId,
          parkSlug: resolvedParkSlug,
          parkName,
        });
      }}
    >
      <Bell size={18} fill={activeAlert ? 'currentColor' : 'none'} />
    </button>
  );
};

export default AttractionNotificationBell;
